import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getFeedbackOptions, submitFeedback } from './thunks';
import { FeedbackState } from './types';

export const name = 'feedback';

const initialState: FeedbackState = {
  feedbackOptions: {
    data: [],
    status: 'idle',
  },
  submitFeedback: {
    status: 'idle',
  },
};

export const getFeedbackOptionsAsync = createAsyncThunk(
  name + '/getFeedbackOptions',
  getFeedbackOptions
);

export const submitFeedbackAsync = createAsyncThunk(
  name + '/submitFeedback',
  submitFeedback
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeedbackOptionsAsync.pending, (state) => {
        state.feedbackOptions.status = 'loading';
      })
      .addCase(getFeedbackOptionsAsync.fulfilled, (state, action) => {
        state.feedbackOptions = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getFeedbackOptionsAsync.rejected, (state) => {
        state.feedbackOptions.status = 'failed';
      })
      .addCase(submitFeedbackAsync.pending, (state) => {
        state.submitFeedback.status = 'loading';
      })
      .addCase(submitFeedbackAsync.fulfilled, (state) => {
        state.submitFeedback.status = 'success';
      })
      .addCase(submitFeedbackAsync.rejected, (state) => {
        state.submitFeedback.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
